import React from 'react';
import { shape, string, bool, func } from 'prop-types';
import { Form } from 'semantic-ui-react';

import styles from './RadioField.less';

const RadioField = props => {
  const {
    label,
    field: { name, value },
    form: { touched, errors, setFieldValue },
    toggle,
    onChange,
  } = props;

  const handleChange = (e, { checked: newValue }) => {
    setFieldValue(name, newValue);
    // eslint-disable-next-line react/destructuring-assignment
    onChange(newValue, props.form);
  };

  return (
    <div>
      {label && <span className={styles.label}>{label}</span>}
      <Form.Radio name={name} checked={value} onChange={handleChange} toggle={toggle} />
      {touched[name] && errors[name] && <div className={styles.error}>{errors[name]}</div>}
    </div>
  );
};

RadioField.propTypes = {
  toggle: bool,
  label: string,
  onChange: func,
  field: shape({}).isRequired,
  form: shape({}).isRequired,
};

RadioField.defaultProps = {
  label: '',
  toggle: false,
  onChange: () => true,
};

export default RadioField;
